import './card-group-list.scss'

import classNames from 'classnames'
import _ from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../button/button'
import { NormalListCard } from '../card/normal-list-card'
import Title from '../title/title'

const INIT_SHOW_NUMBER = 8
const STEP_SHOW = 8

const CardList = ({
  title,
  data,
  shouldLimitShowNumber = true,
  hasNoImage,
  isSearch,
  onClick,
  type = 'event',
}) => {
  const [showNumber, setShowNumber] = useState(INIT_SHOW_NUMBER)
  const { t } = useTranslation()
  useEffect(() => {
    setShowNumber(shouldLimitShowNumber ? INIT_SHOW_NUMBER : data.length)
  }, [data, shouldLimitShowNumber])
  const onShowMore = useCallback(() => {
    setShowNumber((prev) => prev + STEP_SHOW)
  }, [])
  return (
    <section
      className={classNames({
        'container-card-group-list': true,
      })}
    >
      {!_.isEmpty(title) && <Title title={t(`card-group.${title}`)} />}
      <div className="box-cart-group-list">
        {!_.isEmpty(data)
          ? _.map(
              data.slice(0, shouldLimitShowNumber ? showNumber : data.length),
              (card) => (
                <NormalListCard
                  key={card.node ? card.node.id : card.id}
                  item={!_.isEmpty(card.node) ? card.node : card}
                  isSearch={isSearch}
                  hasNoImage={hasNoImage}
                  onClick={onClick}
                  type={type}
                />
              )
            )
          : ''}
        {shouldLimitShowNumber && showNumber < data.length && (
          <div className="box-button-cart-group-list">
            <Button title={t('ui.buttons.more')} onPress={onShowMore} />
          </div>
        )}
      </div>
    </section>
  )
}

export default CardList
